<!--
+------------------------------------------------------------------+
| Author: Jeffrey Thümann                                          |
| Component: NotFound                                              |
| Section: views/special                                           |
| Purpose: Fallback 404 route for unknown or invalid paths.        |
+------------------------------------------------------------------+
-->
<template>
    <div class="not-found">
        <h1>404</h1>
        <h2>{{ $t('notFound.title') }}</h2>
        <p>{{ $t('notFound.subtitle') }}</p>
        <BtnPrimary class="BtnPrimary" :iconFillColor="'var(--brand-text-dark)'" :label="$t('notFound.homeButton')"
            :href="localePath('/')" />
    </div>
</template>

<script>
import BtnPrimary from '@/atoms/BtnPrimary.vue';
import { useLocale } from '@/composables/useLocale';

export default {
    name: 'NotFound',
    components: {
        BtnPrimary
    },
    setup() {
        const { localePath } = useLocale();
        return { localePath };
    },
    mounted() {
        document.title = this.$t('notFound.seoTitle');
    },
};
</script>

<style scoped>
.not-found {
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    pad: 48px;
    background: url('@/assets/noise128x128.png'), var(--brand-color-1);
    background-repeat: repeat;
    background-size: auto;
    overflow: hidden;
}

h1,
h2,
p {
    color: var(--brand-text-light);
}

p {
    margin: 16px 0 32px 0;
}

.BtnPrimary {
    background-color: var(--brand-bg-1);
    color: var(--brand-text-dark);
    border: 2px solid var(--brand-bg-1);
    box-shadow: 0px 0px 0px 0px var(--brand-bg-1);
}

.BtnPrimary:hover {
    box-shadow: 0px 0px 0px 4px var(--brand-bg-1);
}
</style>